import React from 'react';
import debounce from 'lodash/debounce';

import { isAndroid } from '../components/SharedFunctions';

export default function useWindowSize(ref) {
  const [responsiveSize, setResponsiveSize] = React.useState({
    width: ref ? 0 : window.innerHeight,
    height: ref ? 0 : window.innerHeight,
  });
  const updateDimensions = React.useCallback(() => {
    if (ref) {
      const { clientWidth: width, clientHeight: height } = ref.current || {};

      setResponsiveSize({
        height,
        width,
      });
      // https://stackoverflow.com/questions/6031412/detect-android-phone-via-javascript-jquery
    } else if (!isAndroid()) {
      setResponsiveSize({
        height: window.innerHeight || 0,
        width: window.innerWidth || 0,
      });
    }
  }, [ref]);
  const { current: debouncedUpdateDimensions } = React.useRef(debounce(updateDimensions, 250));

  React.useEffect(() => {
    window.addEventListener('resize', debouncedUpdateDimensions);
    debouncedUpdateDimensions();
    return () => {
      debouncedUpdateDimensions.cancel();
      window.removeEventListener('resize', debouncedUpdateDimensions);
    };
  }, [debouncedUpdateDimensions]);

  return responsiveSize;
}
